export const GSTA_LOADER_STYLES = {
 BLACK_SCREEN: "black-screen",
 OPAQUE: "opaque",
}